import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export const isValuePresentInFilter = (value: any): boolean => {
  // check for range, empty when - [null, null]
  const isRangeAndNotEmpty = Array.isArray(value) && value.length > 0;
  if (isRangeAndNotEmpty && value.every((v: any) => !isValuePresent(v))) {
    return false;
  }

  return isValuePresent(value);
}
